import { render, staticRenderFns } from "./annouAction.vue?vue&type=template&id=0d17d7a4"
import script from "./annouAction.vue?vue&type=script&lang=js"
export * from "./annouAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports